import { FunctionalComponent, h } from '@stencil/core';

interface IconProps {
  hasAvatar: boolean;
  hasLabel: boolean;
  hasNotification: boolean;
  forceLabelNotification: boolean;
  handleIconSlotChange: (event: Event) => void;
}

export const Icon = ({ hasAvatar, hasLabel, hasNotification, forceLabelNotification, handleIconSlotChange }): FunctionalComponent<IconProps> => {
  const isLabelNotificationForced = hasNotification && hasLabel && forceLabelNotification;
  const iconHasNotification = hasNotification && !hasAvatar && !isLabelNotificationForced;

  return (
    <span class="icon">
      <slot name="icon" onSlotchange={handleIconSlotChange} />
      {iconHasNotification && <span class="notification" />}
    </span>
  );
};
